import { ArrowDropDownOutlined } from '@mui/icons-material';
import { ButtonProps, Chip, Typography } from '@mui/material';
import { useButtonMenu, PopoverArrow } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { Filter, FilterCategory } from '../../Filters.types';
import { FilterSelectPopoverContent } from '../FilterEditSelectPopoverContent/FilterSelectPopoverContent';

export interface ButtonPopoverProps extends ButtonProps<'div'> {
  selected?: Filter | null;
  items: Filter[];
  favoriteFiltersMaxReached?: boolean;
  categories: FilterCategory[];
  onItemClick: (filter: Filter) => void;
  onItemDelete: (filter: Filter) => void;
  onItemShare: (filter: Filter) => void;
  onItemToggleFavorites: (filter: Filter) => void;
}

export const FilterEditSelect = ({
  items,
  categories,
  children,
  selected,
  onItemClick,
  onItemDelete,
  onItemShare,
  onItemToggleFavorites,
  favoriteFiltersMaxReached,
  ...otherProps
}: ButtonPopoverProps) => {
  const { t } = useTranslation();
  const { menuProps, buttonProps } = useButtonMenu();

  return (
    <>
      <Chip
        label={<Typography variant="button">{t('FilterSelect.label')}</Typography>}
        variant="outlined"
        deleteIcon={<ArrowDropDownOutlined />}
        onDelete={buttonProps.onClick}
        {...otherProps}
        {...(buttonProps as any)}
      />

      <PopoverArrow
        open={menuProps.open}
        anchorEl={menuProps.anchorEl}
        onClose={menuProps.onClose}
        PaperProps={{
          sx: { mt: 3 },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <FilterSelectPopoverContent
          favoriteFiltersMaxReached={favoriteFiltersMaxReached}
          selected={selected}
          categories={categories}
          filters={items}
          onItemClick={(event, filter) => {
            if (menuProps.onClick) {
              menuProps.onClick(event as any);
            }
            onItemClick(filter);
          }}
          onItemDelete={(event, filter) => {
            event.preventDefault();
            event.stopPropagation();
            onItemDelete(filter);
          }}
          onItemShare={(event, filter) => {
            event.preventDefault();
            event.stopPropagation();
            onItemShare(filter);
          }}
          onItemToggleFavorites={(event, filter) => {
            event.preventDefault();
            event.stopPropagation();
            onItemToggleFavorites(filter);
          }}
        />
      </PopoverArrow>
    </>
  );
};
